import styled from 'styled-components'

interface Props {
  children: React.ReactNode
}

function CircleList({ children }: Props) {
  return <Wrapper>{children}</Wrapper>
}

export default CircleList

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;

  width: 100%;
  height: auto;
`
